<template>
  <v-container
    class="products-list-page"
    fluid>
    <member-selector-modal
      :dialog="memberSelectorModal"
      @input="recieveMembers($event)"
      @close-modal="memberSelectorModalClose()" />
    <v-row>
      <v-col
        cols="6">
        <v-card
          class="pa-8"
          outlined
          tile
        >
          <div class="d-flex justify-center align-center mb-6">
            <p class="text-bold mb-0">
              รายชื่อผู้รับข้อความ <span class="red--text">*</span>
            </p>
            <v-spacer />
            <v-btn
              class="pa-0"
              color="secondary"
              text
              @click="showExample = true">
              ตัวอย่างไฟล์สำหรับ Import
              <v-icon
                right
                dark
                color="green"
                class="mr-2"
              >
                mdi-file-download-outline
              </v-icon>
            </v-btn>
            <v-dialog
              v-model="showExample"
              max-width="620">
              <img
                src="@/assets/image/tel_broadcast_example.png"
                alt="">
            </v-dialog>
          </div>
          <csv-reader
            :error="errors"
            class="mb-4"
            :default-icon="''"
            label="เลือกไฟล์ .csv"
            @input="csvHandler($event)" />
          <div
            v-if="errors.length"
            class="csv-fail">
            <div class="d-flex justify-center align-center mb-4">
              <p
                v-if="errors.length"
                class="mb-0">
                พบ error ในไฟล์ที่ Import
              </p>
              <v-spacer />
              <v-btn
                v-if="validationResults.length"
                class="pa-0 text-caption"
                color="secondary"
                text
                @click="exportToCsv">
                download เพื่อแก้ไข
                <v-icon
                  right
                  dark
                  color="green"
                  class="mr-2"
                >
                  mdi-file-download-outline
                </v-icon>
              </v-btn>
            </div>
            <p
              v-for="(errText, index) in errors"
              :key="index"
              class="red--text text-caption">
              {{ index + 1 }} {{ errText }}
            </p>
          </div>
          <v-divider class="my-4" />
          <v-combobox
            v-model="form.members"
            prepend-inner-icon="mdi-label"
            append-icon="mdi-account-box-outline"
            outlined
            dense
            deletable-chips
            hide-selected
            label="ผู้รับ"
            multiple
            hide-details
            persistent-hint
            small-chips
            @keypress="$keypressNumber($event)"
            @change="memberTelsCompute($event)"
            @click:append="memberSelectorModalOpen()" />
          <div
            v-if="!form.members.length"
            class="d-flex flex-column justify-center align-center text-center"
            style="min-height: 100px;">
            <p class="mt-4">
              โปรดเลือกรายชื่อผู้รับข้อความ หรือ Import file
            </p>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          class="pa-8"
          outlined
          tile
        >
          <div>
            <p class="text-bold">
              ชื่อ campaign <span class="red--text">*</span>
            </p>
            <v-text-field
              v-model="campaign"
              label="ชื่อ campaign"
              dense
              persistent-hint
              outlined />
          </div>
          <p class="text-bold mb-0">
            ช่องทางการ Broadcast <span class="red--text">*</span>
          </p>
          <div class="d-flex">
            <v-checkbox
              v-for="(channel, index) in channels"
              :key="`channel-index-${index}`"
              v-model="form.channel"
              :disabled="true"
              class="mr-3"
              :label="channel.label"
              :value="channel.value"
            />
          </div>
          <div v-if="form.channel.includes('sms')">
            <p class="text-bold">
              ข้อความที่ต้องการส่งผ่าน SMS <span class="red--text">*</span>
            </p>
            <v-textarea
              v-model="form.message"
              label="ระบุข้อความ"
              persistent-hint
              hide-details
              outlined />
          </div>
          <v-divider
            v-if="form.channel.includes('line') && form.channel.includes('sms')"
            class="my-6" />
          <div v-if="form.channel.includes('line')">
            <p class="text-bold mb-0">
              ข้อความที่ต้องการส่งผ่านไลน์ <span class="red--text">*</span>
            </p>
            <line-message-box v-model="lineMessage" />
          </div>
          <div class="text-right">
            <v-divider class="my-4" />
            <v-btn
              :disabled="!readyToSendMessage"
              color="primary"
              @click="sendMessages()">
              ส่งข้อความ
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import SmsProvider from '@/resources/SmsProvider'
import LineProvider from '@/resources/LineProvider'
import MemberProvider from '@/resources/MemberProvider'
import MemberSelectorModal from '../components/MemberSelectorModal.vue'
import LineMessageBox from '../components/LineMessage.vue'
import CsvReader from '../components/CsvReader.vue'
import { ExportToCsv } from 'export-to-csv'

const SmsService = new SmsProvider()
const LineService = new LineProvider()
const MemberService = new MemberProvider()

export default {
  components: {
    MemberSelectorModal,
    LineMessageBox,
    CsvReader
  },
  data () {
    return {
      csvContents: [],
      memberSelectorModal: false,
      csvFields: {
        tel: 'memberTel'
      },
      csvData: [],
      form: {
        code: '',
        channel: ['sms'],
        members: [],
        message: ''
      },
      lineMessage: [{ type: 'text', originalContentUrl: '', previewImageUrl: '' }],
      memberSelected: [],
      campaign: '',
      errors: [],
      validationResults: [],
      showExample: false
    }
  },
  computed: {
    channels () {
      return [
        { value: 'sms', label: 'SMS' },
        { value: 'line', label: 'LINE (Coming Soon)' }
      ]
    },
    readyToSendMessage () {
      const hasSmsMessage = this.form.channel.includes('sms') ? !!this.form.message : true
      const hasLineMessage = this.form.channel.includes('line') ? !!this.lineMsgIsValid(this.lineMessage) : true
      const hasPath = this.form.channel.length > 0
      const hasReciever = this.form.members.length > 0
      return hasSmsMessage && hasLineMessage && hasPath && hasReciever && this.campaign && !this.errors.length
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal',
      setLoading: 'Components/setLoading',
      storeSetting: 'Store/storeSetting'
    }),
    validateMemberTelCSV (csvData) {
      const telRegex = /^(?:\+66|0)\d{9}$/
      const validationResults = []
      const errors = []

      // Rule 1: Ensure "memberTel" header exists (case-sensitive)
      if (!csvData.headers.includes('memberTel')) {
        return {
          results: [],
          errors: ["Missing required header: 'memberTel'"]
        }
      }
      if (csvData.results.length === 0) {
        return {
          results: [],
          errors: ['Missing telephone number']
        }
      }
      // Rule 2: Validate each value and collect results + errors
      csvData.results.forEach((row, index) => {
        const tel = row['memberTel']
        let isError = false

        if (typeof tel !== 'string' || tel.trim() === '') {
          errors.push(`Row ${index + 1}: 'memberTel' is empty or missing`)
          isError = true
        } else if (!telRegex.test(tel)) {
          errors.push(`Row ${index + 1}: Invalid 'memberTel' value '${tel}'`)
          isError = true
        }

        validationResults.push({
          memberTel: tel,
          isError: isError ? 'yes' : 'no'
        })
      })

      return {
        results: validationResults,
        errors
      }
    },
    csvHandler (csvContents) {
      if (!csvContents) {
        this.errors = []
        this.form.members = []
        return
      }
      const { results, errors } = this.validateMemberTelCSV(csvContents)
      this.errors = errors
      this.validationResults = results
      if (this.errors.length) return
      const members = csvContents.results.map((each) => (each.memberTel
      ? this.telFormatter(each.memberTel) : null)).filter((each) => each)
      this.form.members = members
    },
    memberSelectorModalOpen () {
      this.memberSelectorModal = true
    },
    memberSelectorModalClose () {
      this.memberSelectorModal = false
    },
    recieveMembers (members) {
      this.memberSelected = members
      this.form.members = this.memberTelsTransform(members)

      this.memberSelectorModalClose()
    },
    memberTelsTransform (members) {
      return members.map((member) => this.telFormatter(member.tel, member.telInfo?.dialCode))
    },
    telFormatter (_tel, dialCode = '66') {
      let tel = _tel
      if (tel[0] === '6' && tel[1] === '6') {
        tel = `+${tel}`
      } else if (tel[0] !== '+' && dialCode === '66') {
        tel = `+66${tel.slice(1)}`
      }

      return tel
    },
    async getMembersByTels (payload) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'GET MEMBERS DATA...'
        })

        const { data } = await MemberService.getMembersByTels(payload)
        this.memberSelected = data
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[GET MEMEBERS ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setLoading({ active: false })
      }
    },
    selectPath (members) {
      const results = {
        sms: [],
        line: []
      }

      members.forEach((member) => {
        const found = member.otherOptions.find((option) => option.key === 'line-uid')
        const lineUid = found ? found.value : null
        if (lineUid) {
          results.line.push(member)
        } else {
          results.sms.push(member)
        }
      })

      return results
    },
    async sendMessages () {
      try {
        if (this.memberSelected.length !== this.form.members) {
          await this.getMembersByTels({ tels: this.form.members })
        }

        if (this.form.channel.length > 1) {
          const pathChosens = this.selectPath(this.memberSelected)
          await this.preparedToSendSMS(pathChosens.sms)
          await this.preparedToSendLine(pathChosens.line)
        } else if (this.form.channel[0] === 'sms') {
          this.preparedToSendSMS(this.memberSelected)
        } else if (this.form.channel[0] === 'line') {
          this.preparedToSendLine(this.memberSelected)
        }
      } catch (e) {
        this.setSnackbar({
          value: true,
          message: `[SEND MESSAGE(S) ERROR]: ${e.message}`,
          type: 'error'
        })
        console.error(`[SEND MESSAGE(S) ERROR]: ${e.message}`)
      }
    },
    async preparedToSendSMS (members) {
      const messages = []
      members.forEach((member) => {
        messages.push({
          form: this.storeSetting?.smsSetting?.senderName ? this.storeSetting.smsSetting.senderName.toUpperCase() : 'SMS',
          to: this.telFormatter(member.tel, member.telInfo?.dialCode),
          text: this.form.message,
          member: {
            id: member.id,
            tel: this.telFormatter(member.tel, member.telInfo?.dialCode),
            firstName: member.firstName,
            lastName: member.lastName
          },
          campaign: this.campaign
        })
      })

      if (messages.length > 0) {
        await this.sendSmsMessage({ messages })
      }
    },
    async preparedToSendLine (members) {
      const messages = []
      members.forEach((member) => {
        const found = member.otherOptions.find((option) => option.key === 'line-uid')
        const lineUid = found ? found.value : null
        if (lineUid) {
          const tempMessage = this.lineMessage.map((each) => {
            let temp = each
            if (each.type === 'text') {
              temp = {
                type: 'text',
                text: each.text
              }
            } else if (each.type === 'image') {
              temp = {
                type: 'image',
                originalContentUrl: each.originalContentUrl,
                previewImageUrl: each.originalContentUrl
              }
            }

            return temp
          })

          messages.push({
            to: [lineUid],
            messages: tempMessage,
            member: {
              id: member.id,
              tel: this.telFormatter(member.tel, member.telInfo?.dialCode),
              firstName: member.firstName,
              lastName: member.lastName
            }
          })
        }
      })

      if (messages.length > 0) {
        await this.sendLineMessage({ data: messages })
      }
    },
    async sendLineMessage (payload) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'SENDING LINE MESSAGES...'
        })

        await LineService.sendMulti(payload)
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[SEND LINE ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setSnackbar({
          value: true,
          message: 'SEND LINE MESSAGE(S) COMPLETE',
          type: 'success'
        })
        this.setLoading({ active: false })
      }
    },
    async sendSmsMessage (payload) {
      try {
        this.setLoading({
          active: true,
          clickAble: false,
          message: 'SENDING SMS MESSAGES...'
        })

        await SmsService.sendMulti(payload)
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: `[SEND SMS ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.setSnackbar({
          value: true,
          message: 'SEND SMS MESSAGE(S) COMPLETE',
          type: 'success'
        })
        this.setLoading({ active: false })
      }
    },
    memberTelsCompute (tels) {
      this.form.members = [...new Set(tels.map((tel) => this.telFormatter(tel)))]
    },
    lineMsgIsValid (messages) {
      if (!messages.length) return false
      const validMsg = messages.every((msg) => {
        if (msg.type === 'text') {
          return typeof msg.text === 'string' && msg.text.trim() !== ''
        }
        if (msg.type === 'image') {
          return (
            typeof msg.originalContentUrl === 'string'
            && msg.originalContentUrl.trim() !== ''
            && typeof msg.previewImageUrl === 'string'
            && msg.previewImageUrl.trim() !== ''
          )
        }
        return true
      })
      return validMsg
    },
    exportToCsv () {
      const options = {
        filename: 'fix_member_tel',
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(this.validationResults)
    }
  }
}
</script>

<style scoped>
.main-row {
  padding: 10px 10px;
}

.template-text {
  white-space: pre-line;
}

.text-preview-box {
  white-space: pre-wrap;
  line-height: 1.35em;
}

.csv-table-header-box {
  padding: 2px;
  border: 1px solid black;
}
.csv-fail {
  max-height: 200px;
  overflow-y: scroll;
  border: 2px solid red;
  padding: 12px;
}
</style>
